<app-base-edit-form-modal
  [fields]="fields"
  [id]="id"
  [parentId]="shippingInterfaceHeaderId"
  [baseService]="shipperInterfaceDetailsService"
>
</app-base-edit-form-modal>
